import { Component, Inject, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Action } from 'vuex-class';

import SlideMixin from '@mixins/SlideMixin';
import JumpLinksMixin from '@/mixins/JumpLinksMixin';
import GpSwiper from '@comps/GpSwiper/index.vue';

import { getMossBannerById, getInfoProviderById } from '@api/json';

import { getV4MixedList } from '@api/gicp';

import { isEmpty, isArray, copy, shuffle, formatDate, getEnv } from '@tencent/slug-function';
import { jsonFilterByTime, openFullScreen } from '@/utils';
import { reportClick } from '@utils/report';
import { replaceImgToCloud } from '@utils/cloud-img.js';
import { script as getScript } from '@utils/script.js';
const { isSlugSDK } = getEnv();
// import { getLCP, getFID, getCLS, getFCP, getTTFB } from 'web-vitals';
// eslint-disable-next-line no-underscore-dangle
declare const aegis: any;
interface ListItem {
  id: string;
  images: string;
  title?: string;
  url?: string;
  disabled?: boolean;
  ptt?: [string, string, string];
  dmp?: {
    [propName: string]: any;
  };
  isCloseFullScreen?: boolean
}
@Component({
  components: {
    'gp-swiper': GpSwiper,
  },
  filters: {
    formatDate,
  },
})
class SelectedPage extends mixins(SlideMixin, JumpLinksMixin) {
  // 设置红点
  @Action('setRedPoint') actionSetRedPoint: any;

  // public info: any = this.$store.state.strategyList;
  public currentNum = -1;

  public infoTab: any[] = [
    { id: 3996, name: '资讯' },
    { id: 4000, name: '新闻' },
    { id: 4001, name: '公告' },
    { id: 4003, name: '活动' },
    { id: 4467, name: '赛事' },
  ];

  // public currentHotBannerImgList: any[] = []; // 当前热门 Banner图片list

  // public currentHotBanner: any[] = []; // 当前热门 Banner
  // public entryList: any[] = []; // 固定入口
  // public seeSetList: any[] = []; // 大神宝典 tag
  public currentHotBanner: any[] = (window as any).gpIngameData?.bannerList || []; // 当前热门 Banner
  // public entryList: any[] = (window as any).gpIngameData?.entryList || []; // 固定入口
  public entryList: any[] = [{
    id: 9847,
    title: '地图资源',
    url: 'https://sy.qq.com/gp/map',
    images: 'https://sy-1254960240.image.myqcloud.com/gp/ingame/images/202010/20201013112500-164963.png',
    recommended: '',
    ptt: ['btn', 'hot-quick-地图资源', '当前热门右侧快捷入口'],
  }, {
    id: 9573,
    title: '大神灵敏度',
    url: 'https://sy.qq.com/gp/sensitivity',
    images: 'https://sy-1254960240.image.myqcloud.com/gp/ingame/images/202010/20201013112513-678768.png',
    recommended: '',
    ptt: ['btn', 'hot-quick-大神灵敏度', '当前热门右侧快捷入口'],
  }, {
    id: 9590,
    title: '福利站',
    url: 'https://sy.qq.com/gp/calendar',
    images: 'https://sy-1254960240.image.myqcloud.com/gp/ingame/images/202010/20201013112506-750168.png',
    recommended: '',
    ptt: ['btn', 'hot-quick-福利站', '当前热门右侧快捷入口'],
  }, {
    id: 9864,
    title: '玩家调研',
    url: 'https://wj.qq.com/s2/6810774/409f/',
    images: 'https://sy-1254960240.image.myqcloud.com/gp/ingame/images/202010/20201013112452-113600.png',
    recommended: '',
    ptt: ['btn', 'hot-quick-玩家调研', '当前热门右侧快捷入口'],
  }];

  public seeSetList: any[] = (window as any).gpIngameData?.seeSetList || []; // 大神宝典 tag

  public infoBanner: any[] = []; // 最新资讯 Banner
  public infoList: any[] = []; // 最新资讯 tab
  public observeSeeSetList: any;
  public seeSetLoad = 0;
  // public observeEntryListReport = false;
  public observeSeeSetListTimeNew = 0;
  public vueMountRenderTime2New = 0;

  public initBnnerData = {
    images: 'https://gzhcos.qq.com/gp-ingame/img/home-bannner.jpg',
    url: 'https://sy.qq.com/gp/stragegy',
    title: '夺冠入门，萌新必看',
  }; // 无轮播时的默认数据

  public isHideCont = false;

  @Inject({
    default: {},
  })
  public $userAgent: any;

  @Watch('currentNum')
  public async watchCurrentNum(val: any) {
    this.infoList = [];

    const { data: { items } } = await getV4MixedList({
      filter: 'channel',
      chanid: this.infoTab[val].id,
      limit: 10,
    });

    this.infoList = this.infoList.concat(items || []);
  }

  // @Watch('seeSetListAll')
  // public watchSeeSetListAll(val: any) {
  //   if (isEmpty(val)) {
  //     this.seeSetList = Array.from({ length: 10 }).map((_item, index) => ({
  //       id: index + 1,
  //       config_title: '',
  //       title: '',
  //       recommended: '',
  //     }));
  //   } else {
  //     this.$nextTick(() => {
  //       // 第一次，打乱后，sort为0的往前排
  //       this.seeSetList = shuffle(copy(this.seeSetListAll, 1))
  //         .sort((_a, b) => {
  //           if (b.sort === 0) {
  //             return 1;
  //           }
  //           return 0;
  //         })
  //         .slice(0, 10);
  //     });
  //   }
  // }


  public mounted() {
    this.loadWhiteLink()
    if ((window as any).gpIngameData) {
      // console.log(JSON.stringify((window as any).gpIngameData), 'gpIngameData');
    } else {
      (window as any).gpIngameData = {};
    }


    this.getSeeSetList();

    this.$store.dispatch('initGetRedPoint');

    // 获取当前热门Banner
    this.getCurrentHotBannerList();
    // 获取首页入口
    // this.getEntryList();
    // 获取资讯Banner
    this.getInfoBannerList();

    // 进入过精选，点掉红点
    this.actionSetRedPoint({ module: 'walkthrough', key: 'selected', value: 0 });

    this.currentNum = 0;


    window.onload = () => {
      if (location.host.indexOf('localhost') >= 0 && Object.keys((window as any).gpIngameData).length === 2) {
        const script = document.createElement('script');
        script.innerHTML = `window.gpIngameData=${JSON.stringify((window as any).gpIngameData)}`;
        const placeholder = '<!-- prerender-data -->';
        if (document.documentElement.innerHTML.includes(placeholder)) {
          const html = document.documentElement.innerHTML.replace(placeholder, script.outerHTML);
          document.documentElement.innerHTML = html;
        } else {
          (document.querySelector('head') as any).appendChild(script);
        }
        document.dispatchEvent(new Event('render-event'));
        // const cdnUrl = '<script src="https://gzhcos.qq.com/gp-ingame/pre-data/index-data2.js"></script>';
        // const placeholder = '<!-- prerender-data -->';
        // if (document.documentElement.innerHTML.includes(placeholder)) {
        //   const html = document.documentElement.innerHTML.replace(placeholder, cdnUrl);
        //   document.documentElement.innerHTML = html;
        // }
      }

      if (window.location.href.indexOf('/gp/index') >= 0) {
        const { timing } = performance;
        aegis.reportTime('domContentLoadedEventEnd', timing.domContentLoadedEventEnd - timing.fetchStart);
        console.log(timing.domContentLoadedEventEnd - timing.fetchStart, 'domContentLoadedEventEnd');
        aegis.reportTime('onload', ((new Date()).valueOf() - performance.timing.fetchStart));
        console.log(new Date().valueOf() - performance.timing.fetchStart, 'onload');

        aegis.reportTime('vueMountRenderTime2New', this.vueMountRenderTime2New);
        aegis.reportTime('observeSeeSetListTimeNew', this.observeSeeSetListTimeNew);
        aegis.reportTime('seeSetLoad', this.seeSetLoad);

        console.log(this.vueMountRenderTime2New, 'vueMountRenderTime2New');
        console.log(this.observeSeeSetListTimeNew, 'observeSeeSetListTimeNew');
      }
    };
  }


  public full() {
    const isBOXSDK = /ESTV/i.test(navigator.userAgent); // 判断boxua
    if (isSlugSDK || isBOXSDK) {
      console.log('boxsdk或者slugsdk触发');
      return;
    }
    openFullScreen();
  }
  public handleImg(url: string, config: string) {
    return replaceImgToCloud(url, config);
  }
  // public observe() {
  //   try {
  //     // (document.getElementsByClassName('boutique-box')[0]
  //     //  as HTMLElement).addEventListener('DOMSubtreeModified', () =>  {
  //     //   if (!this.observeSeeSetListReport) {
  //     //     console.log(this.seeSetList);
  //     //     console.log('大神宝典中子元素被修改');
  //     //     aegis.reportTime('observeSeeSetListReport', ((new Date()).valueOf() - performance.timing.fetchStart));
  //     //     this.observeSeeSetListReport = true;
  //     //   }
  //     // }, false);

  //     // Firefox和Chrome早期版本中带有前缀
  //     const MutationObserver = window.MutationObserver
  //     || (window as any).WebKitMutationObserver || (window as any).MozMutationObserver;
  //     // 选择目标节点
  //     const target = document.getElementsByClassName('boutique-box')[0];
  //     // 创建观察者对象
  //     this.observeSeeSetList = new MutationObserver(() => {
  //       aegis.reportTime('observeSeeSetListTime', ((new Date()).valueOf() - performance.timing.fetchStart));
  //       aegis.reportTime('vueMountRenderTime2', (new Date()).valueOf() - (window as any).mountTime);
  //       this.seeSetLoad && aegis.reportTime('seeSetLoadTime', this.seeSetLoad);

  //       console.log(new Date().valueOf() - performance.timing.fetchStart, 'observeSeeSetListTime');
  //       console.log((new Date()).valueOf() - (window as any).mountTime, 'vueMountRenderTime2');
  //       console.log(this.seeSetLoad, 'seeSetLoadTime');
  //       console.log('大神宝典中子元素被修改', this.seeSetList);
  //       // 停止观察
  //       this.observeSeeSetList.disconnect();
  //     });
  //     // 配置观察选项:
  //     const config = { subtree: true, attributes: true, childList: true  };
  //     // 传入目标节点和观察选项
  //     this.observeSeeSetList.observe(target, config);
  //   } catch (error) {
  //     aegis.error(new Error(JSON.stringify(error)));
  //   }
  // }
  // 获取大神宝典list
  public async getSeeSetList() {
    // this.observe();
    this.vueMountRenderTime2New = (new Date()).valueOf() - (window as any).mountTime;
    this.observeSeeSetListTimeNew = (new Date()).valueOf() - performance.timing.fetchStart;

    try {
      let list = (window as any).gpIngameData.seeSetList || [];
      if (list.length <= 0) {
        const { data } = await getMossBannerById(88, true);
        list = this.getCopyList(data);
        (window as any).gpIngameData.seeSetList = list;
      }
      this.seeSetList = list;
      this.seeSetLoad = new Date().valueOf() - performance.timing.fetchStart;
      // this.observeSeeSetList && aegis.reportTime('seeSetLoad', ((new Date()).valueOf() - performance.timing.fetchStart));
    } catch (error) {
      console.log('getEntryList', error);
    }
  }

  // 快捷入口
  // public get quickEntry() {
  //   let entry = copy(this.entryList, -1);
  //   const entryIsEmpty: boolean = isEmpty(entry);

  //   // 为空时给出默认值给 skeleton 占位
  //   if (entryIsEmpty || !isArray(entry)) {
  //     entry = Array.from({ length: 4 }).map((_item, index) => ({
  //       id: index + 1,
  //       config_title: '',
  //       title: '',
  //     }));
  //   }

  //   return {
  //     list: entry.slice(0, 4),
  //     showSkeleton: entryIsEmpty,
  //   };
  // }

  public get currentInfoTabName() {
    if (this.infoTab[this.currentNum]) {
      return this.infoTab[this.currentNum].name;
    }
    return '';
  }

  public get ads() {
    return this.$store.state.ads;
  }

  // public get indexStates() {
  //   return this.$store.state.indexStates;
  // }

  // public get indexList() {
  //   return this.$store.state.indexList;
  // }

  public get isRecommand() {
    return !this.$route.params.tagId || parseInt(this.$route.params.tagId, 10) === 4018;
  }

  public get tagId_() {
    if (this.infoTab[this.currentNum]) {
      return this.infoTab[this.currentNum].id;
    }
    return {};
  }

  public getCopyList(list: any[]) {
    interface Item {
      id: string,
      title: string,
      url: string,
      images: string,
      recommended: string
    }
    const cList: Item[] = [];
    list.forEach((element: any) => {
      const { id, title, url, images, recommended  } = element;
      cList.push({
        id,
        title,
        url,
        images,
        recommended,
      });
    });
    return cList;
  }
  // 获取当前热门轮播Banner
  public async getCurrentHotBannerList() {
    let list = (window as any).gpIngameData.bannerList || [];
    if (list.length <= 0) {
      const { data } = await getMossBannerById(105, true);
      list = this.getCopyList(jsonFilterByTime(data));
      this.currentHotBanner = list.map((item: any) => {
        item.ptt = ['link', `hothits-${item.title}`, '当前热门banner'];
        return item;
      });
      (window as any).gpIngameData.bannerList = this.currentHotBanner;
      // return;
    }
    if (list.length <= 0) {
      const item = {
        ...this.initBnnerData,
        ptt: ['link', `backup-${this.initBnnerData.title}`, '当前热门banner'],
      };
      this.currentHotBanner = [item];
    }
  }

  public toUrl(item: ListItem) {
    const { disabled, url, isCloseFullScreen } = item;

    if (disabled) return;
    // this.emitItemClick(item);
    if (typeof url === 'string') {
      this.jumpLinks(url, isCloseFullScreen);
    }
  }
  // 获取固定入口json
  public async getEntryList() {
    try {
      let list = (window as any).gpIngameData.entryList || [];
      if (list.length <= 0) {
        const { data  } = await getInfoProviderById(1414);
        list = this.getCopyList(data);
        (window as any).gpIngameData.entryList = list;
      }


      this.entryList = list.map((item: any) => {
        item.ptt = ['btn', `hot-quick-${item.title}`, '当前热门右侧快捷入口'];
        return item;
      });
    } catch (error) {
      console.log('getEntryList', error);
    }
  }

  // 获取资讯Banner
  public async getInfoBannerList() {
    const { data } = await getMossBannerById(1021);
    const list = jsonFilterByTime(data);
    if (list && list.length > 0) {
      this.infoBanner = list.map((item: any) => {
        item.ptt = ['btn', `news-round-${item.title}`, '资讯轮播点击'];
        return item;
      });
    } else {
      const item = {
        ...this.initBnnerData,
        ptt: ['btn', `backup-${this.initBnnerData.title}`, '资讯轮播点击'],
      };
      this.infoBanner = [item];
    }
  }

  // 大神宝典换一换
  public changeSeeSet() {
    this.seeSetList = shuffle(copy(this.seeSetList, 1));
  }

  public toDetail(item: any) {
    const v4ExtParams = {
      clickUrl: `#/${item.iInfoType === 1 ? 'news-detail' : 'video-detail'}/`,
      contentType: item.iInfoType === 1 ? 'news' : 'video',
      contentSource: 'index.0.0.0.list',
    };
    const useractionExtParams = {
      routeName: 'index',
      contentType: item.iInfoType === 1 ? 'picture' : 'video',
    };
    // 上报
    reportClick(v4ExtParams, useractionExtParams);
    const name = item.iInfoType === 1 ? 'news-detail' : 'video-detail';
    this.$router.push({
      name,
      params: {
        id: item.iId,
      },
    });
  }

  public async loadWhiteLink() {
    // eslint-disable-next-line no-underscore-dangle
    if (!window._whiteName) {
      await getScript({
        url:
          'https://tiem-cdn.qq.com/slugteam/common/js/white-plugins.js',
        loadRemove: false,
      });
    }
    // eslint-disable-next-line no-underscore-dangle
    window._whiteName({
      eleId: 'whiteLinkBtn20251020', // 绑定点击弹出框的元素
      game: 'gp', // 游戏id 如 hlddz
    });
  }
}

export default SelectedPage;
